import {NgModule} from '@angular/core';
import {ArticleBlockComponent} from './article-block.component';
import {ARTICLE_BLOCK_PROVIDERS} from './article-block.providers';

@NgModule({
  declarations: [ArticleBlockComponent],
  exports: [ArticleBlockComponent],
  providers: [ARTICLE_BLOCK_PROVIDERS],
})
export class ArticleBlockModule {}
